import React from "react"
import style from "./ButtonArea.module.css"
const ButtonArea = ({ children }) => {
  return <div className={style.outer}>{children}</div>
}

export default ButtonArea
